import axios from "axios";
import { baseUrl } from "../config";

const api = axios.create({
  baseURL: baseUrl,
  timeout: 180000, //3 minute
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("@wirasana-token");
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
